module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CH-T"
  }, [_c('strong', [_vm._v("Composites and Further Special Effects")])]), _vm._v(" "), _c('p', {
    staticClass: "CH-INTRO1"
  }, [_vm._v("In many ways, Photoshop was designed to allow the user to make sophisticated montages and composites. Unlike traditional photography, you are now able to make very accurate selections, which makes the task of importing elements from one file into another considerably easier. It is important that you carefully note the details of each of your files to ensure that, should you wish to make a composite, the elements match in terms of lighting, colour temperature and viewpoint.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43bca07d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c01.vue
// module id = 66
// module chunks = 0